// extracted by mini-css-extract-plugin
export default {"mainContainer":"Landing_mainContainer__lfwDy"};